// ROOTS
export const ROOT_PUBLIC = '/public';
export const LOGIN_REDIRECT = (url: string) => ROOT_PUBLIC + '/login/' + url;
export const INFO = '/info';

// SECURED
export const ROOT_SECURED = '/secured';
export const WELCOME = ROOT_SECURED + '/welcome';
export const WIZARD = ROOT_SECURED + '/wizard';
export const CONSENT = ROOT_SECURED + '/consent';
export const QUESTIONNAIRE = (consentId: string) => ROOT_SECURED + '/questionnaire/' + consentId;
export const SUBMITTED_CONSENTS = ROOT_SECURED + '/submitted-consents';
export const SUBMITTED_CONSENT = (id: string) => SUBMITTED_CONSENTS + '/' + id;
export const OVERVIEW = (consentId: string) => ROOT_SECURED + '/submitted-consents/overview/' + consentId;
export const PATIENT_CONSENT_OVERVIEW = (consentId: string) => ROOT_SECURED + '/consent-overview/' + consentId;
export const BASIC_CONSENT = (consentId: string) => ROOT_SECURED + '/basic/' + consentId;
export const USER_MANAGEMENT = ROOT_SECURED + '/user-management';
export const SINGLE_COMMENT = ROOT_SECURED + '/single-comment';
export const EXPORT = ROOT_SECURED + '/export';
export const FORM = ROOT_SECURED + '/form';
export const CMS = ROOT_SECURED + '/cms';
export const CMS_INDICATIONS = CMS + '/indications';
export const CMS_IMAGES = CMS + '/images';
export const CMS_SPECIFIC_INDICATION = (id: string) => CMS_INDICATIONS + '/' + id;
export const SUPER_ADMIN = ROOT_SECURED + '/manage';
export const DATA_PROCESSING = '/data-processing';
export const SETTINGS = ROOT_SECURED + '/settings';
export const MEDICATION_MANAGEMENT = ROOT_SECURED + '/medication-management';
